import React from "react";
import portfolioPhoto from "../../assets/images/portfolioProfileImage.png";
import "./FeelingProud.css";

function FeelingProud(props) {
  // const theme = props.theme;
  return <img src={portfolioPhoto} alt="portfolio-profile" />;
}

export default FeelingProud;
